<template>
  <main>
    <ticker-admin-nav />
    <h4>Universal Security Master </h4>
    <h5>Cryptos</h5>
    <article class="row">
      <section class="input-field col s5">
        <input id="usm-overview-search"
               class="validate"
               type="text"
               name="search"
               placeholder="e.g. Bitcoin"
               @keyup.enter="searchQuery($event)"
        >
        <label class="active" for="usm-overview-search">
          <i class="fas fa-search small unclickable"
             title="Some info tooltip, not sure what Brandon wanted"
          />
          Search Crypto
          <span class="progress" v-show="searching"><span class="indeterminate" /></span>
        </label>
        <span class="helper-text left teal-text text-lighten-3">
          <strong>Type and hit "Enter"</strong>
        </span>
      </section>
      <section id="reset-btn" class="col s1">
        <a class="strong clickable" @click.prevent="resetFields()">Reset</a>
      </section>
    </article>
    <article class="row">
      <section class="col s12">
        <label class="pink-text left" v-if="cryptos.length > 99">
          Showing Top 100 Results
        </label>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th class="center-align">Active</th>
              <th>Quoted As</th>
              <th>Instrument ID</th>
              <th>Symbol</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="crypto in this.cryptos" :key="crypto.instrument_id" class="instrument-link-wrapper">
              <td class="strong">
                {{ crypto.name}}
              </td>
              <td class="center-align">
                <i class="fas fa-check-circle green-text" v-if="!crypto.inactive_date" />
                <span class="red-text">{{ crypto.inactive_date }}</span>
              <td>
              {{crypto.quoted_as}}
              </td>
              <td>{{crypto.id}}</td>
              <td>
                    <router-link :to="`/tickeradmin/viewcrypto?instrument_id=${crypto.id}`"
                                 class="instrument-link"
                    >
                      {{crypto.symbol}}
                    </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </article>
    <aside class="usm-add-security-button-wrapper" v-show="$auth.hasRoles('admin', 'recs-admin', 'contractor-usm-admin')">
      <router-link to="/tickeradmin/addcrypto" style="display: inline-block">
        <button class="btn-floating btn-large waves-effect waves-light teal accent-4">
          <i class="fas fa-plus" />
        </button>
        <label>Add Crypto</label>
      </router-link>
    </aside>
  </main>
</template>

<script>
import axios from 'axios';
import TickerAdminNav from '@/components/TickerAdminNav.vue';

export default {
  name: 'CryptoAdminListCryptos',
  components: { TickerAdminNav },
  props: {},
  data() {
    return {
      query: 'Bitcoin',
      cryptos: [],
      searching: false,
    };
  },
  methods: {
    searchQuery(evt) {
      const { value } = evt.target;
      this.query = value;
      this.searchCryptos();
    },
    async searchCryptos() {
      const params = {
        query:this.query
      };
      if (this.query) {
        this.searching = true;
        try{
          const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/search_crypto/?q=${params.query}`);
          this.cryptos = data;
        }catch(err){
            this.cryptos = []
        }
        setTimeout(() => {
          this.initTooltip();
        }, 200);
        this.searching = false;
      }
    },
    initTooltip() {
      this.materialize.Tooltip.init(document.querySelectorAll('.tooltipped'), {
        position: 'top',
      });
      document.getElementsByClassName('material-tooltip').forEach(elem => {
        elem.style.borderRadius = '10px';
        elem.style.backgroundColor = '#424242';
      });
    },
    resetFields() {
      this.query = 'Bitcoin';
      this.searchCryptos();
    },
  },
  async mounted() {
    await Promise.all([
      this.searchCryptos(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.usm-add-company-aside {
  position: absolute;
  top: 100px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}

.instrument-link-wrapper {
  margin: 0px;
  & > .instrument-link {
    transition: color 0.25s;
    &:hover {
      color: #ffab00;
    }
  }
}

.avatar {
  height: 40px;
  border: 1px solid $tmf-gains;
  margin-bottom: -10px;
}

.usm-add-security-button-wrapper {
  position: absolute;
  top: 100px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}

.progress {
  width: 80px;
  display: inline-block;
  position: relative;
  top: 10px;
}

#reset-btn {
  margin-top: 30px;
}
</style>
